import { Helmet } from 'react-helmet-async';

import { AdaLogo } from '~/components/AdaLogo';
import { WmgLogo } from '~/components/WmgLogo';
import { env } from '~/lib/env';
import { AdaOktaConfig } from '~/modules/branding/auth/ada-okta-config';
import { WmgOktaConfig } from '~/modules/branding/auth/wmg-okta-config';
import type { Brand, BrandType } from '~/modules/branding/types';
import AdaThemeCssInline from '~/styles/theme-ada.css?inline';
import WmgThemeCssInline from '~/styles/theme-wmg.css?inline';

// TODO WMG1-515
/* eslint-disable @typescript-eslint/no-useless-template-literals */
export const BRANDS: Record<BrandType, Brand> = {
  WMG: {
    name: 'WMG',
    product: 'WMG1',
    title: 'WMG One',
    titleTemplate: '%s | WMG One',
    oktaConfig: WmgOktaConfig,
    pulseInsightsToken: env('VITE_WMG_PULSE_INSIGHTS_TOKEN', false) || '',
    meta: (
      <Helmet>
        <style>{`${WmgThemeCssInline}`}</style>
      </Helmet>
    ),
    logo: <WmgLogo />,
    defaultQueryOptions: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
  ADA: {
    name: 'ADA',
    product: 'ADA',
    title: 'ADA',
    titleTemplate: '',
    oktaConfig: AdaOktaConfig,
    pulseInsightsToken: env('VITE_ADA_PULSE_INSIGHTS_TOKEN', false) || '',
    meta: (
      <Helmet>
        <style>{`${AdaThemeCssInline}`}</style>
      </Helmet>
    ),
    logo: <AdaLogo className="text-primary-default" />,
    defaultQueryOptions: {},
  },
};
